import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import UpdateShiftTypeCompanyForm from "../../components/forms/UpdateShiftTypeCompanyForm";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const UpdateShiftTypeCompanyPage = (props) => (
  <Page enableGoBack title="Dienstsoortprijs voor bedrijf wijzigen">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienstsoortprijs voor bedrijf wijzigen">
        <UpdateShiftTypeCompanyForm
          shiftTypeId={props.match.params.shifttype_id}
          companyEmail={props.match.params.company_email}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

UpdateShiftTypeCompanyPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      shifttype_id: PropTypes.string.isRequired,
      company_email: PropTypes.string.isRequired,
    }),
  }),
};

export default UpdateShiftTypeCompanyPage;



// WEBPACK FOOTER //
// ./src/pages/ShiftTypeCompany/UpdateShiftTypeCompanyPage.js